export default (): void => {
  document.addEventListener("DOMContentLoaded", (): void => {
    /**
     * click listener for cart button
     */
    const cartButton = document.getElementById("cartButton");
    const cart = document.getElementById("siteMinicart");
    cartButton.addEventListener("click", (): void => {
      cart.toggleAttribute("hidden");
    });

    /**
     * minicart close button
     */
    const closeButton = document.getElementById("minicartClose");
    closeButton.addEventListener("click", (): void => {
      cart.setAttribute("hidden", "");
    });

    /**
     * collapse minicart with external click
     */
    function getPath(event): any {
      if (event.composedPath) {
        return event.composedPath();
      }

      let path = [];
      let target = event.target;

      while (target.parentNode) {
        path.push(target);
        target = target.parentNode;
      }

      path.push(document, window);

      return path;
    }

    document.addEventListener("click", event => {
      const path = getPath(event);

      if (path && path.length > 0) {
        const eventFromMenu = path.filter(el => {
          return (
            el.classList &&
            (el.classList.contains("site--minicart") ||
              el.classList.contains("site--cart-button"))
          );
        });

        if (eventFromMenu.length == 0) cart.setAttribute("hidden", "");
      }
    });
  });
};
